<template>
  <div v-if="!chartOptionsList.length" class="vh-100 text-center pt-5" >{{ $t('nwp.loading_chart') }}...</div>
  <div v-on:mouseleave="hideTooltips" class="aladin-chart" v-else>
    <div class="mb-1 text-center d-flex justify-content-center">
      <div class="ml-3"><input type="checkbox" v-model="syncTooltip" name="syncTooltip" value="1" id="syncTooltip"><label for="syncTooltip">Synchronizované popisky</label></div>
    </div>

    <h3 class="text-center"> {{ json_data.location_name }} ({{ json_data.elevation }}m)</h3>

    <highcharts ref="highcharts" :class="`chart-`+height"
                v-for="(chartOptions, index) in chartOptionsListOnlyActive"
                :key="index + `-` + chartOptions.id"
                :options="chartOptions"
    >
    </highcharts>
  </div>
</template>

<script>

import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import Accessibility from 'highcharts/modules/accessibility';
import Highstock from 'highcharts/modules/stock';
import Windbarb from 'highcharts/modules/windbarb';
import HighchartsVue, {Chart} from 'highcharts-vue';
import myMixin from './mixin';
import {rgbaToRgb} from "@amcharts/amcharts4/.internal/core/utils/Colors";

HighchartsMore(Highcharts);
Highstock(Highcharts);
Windbarb(Highcharts);
Accessibility(Highcharts);

Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'],
    resetZoom: 'Zrušiť priblíženie'
  },
  global: {
    useUTC: true
  }
});


Highcharts.Pointer.prototype.reset = function () {
  return undefined;
};



export default {
  components: {
    highcharts: Chart
  },
  mixins: [myMixin],
  props: [
    'json_data_multi',
    'json_station',
    'json_type',
    'vars',
    'height',
    'tz'
  ],
  data: function () {
    return {
      isLoading: true,
      chartOptionsList: [],
      syncTooltip: false,
    }
  },
  computed: {
    json_data() {
      if (this.json_data_multi.length) {
        return this.json_data_multi[0].data;
      }
      return null;
    },
    chartOptionsListOnlyActive() {
      const self = this;
      if (this.chartOptionsList.length > 0) {
        return this.chartOptionsList.filter((item) => {
          if (self.vars.includes(item.id)) return true;
          return false;
        });
      }
      return this.chartOptionsList;
    },
    computedTickInterval() {
      if (this.json_data) {
        let rozdiel  = this.json_data.Air_temperature_at_2m.data[1][0] - this.json_data.Air_temperature_at_2m.data[0][0];
        return rozdiel * 1000;
      }
      return 1 * 60 * 60 * 1000;
    }
  },
  watch: {
    json_data(v) {
      this.isLoading = true;
      this.prepareData();
    },
    isLoading(v) {
      // console.log('emitujem', this.isLoading);
      this.$emit("isChartLoading", this.isLoading);
    },
    height(v) {
      this.redrawCharts();
    },
    tz(v) {
      const self = this;
      let utc = true;
      if (v !== 'utc') utc = false;
      Highcharts.setOptions({
        global: {
          useUTC: utc
        }
      });
      this.redrawCharts();
      this.$nextTick(function() {
        self.prepareData();
      });

    },
    syncTooltip(v) {
      const self = this;
      this.$ls.set('meteogram_sync_tooltip', v, 365 * 60 * 60 * 1000); // 1 rok

      if (this.$refs.highcharts && this.$refs.highcharts.length) {
        this.hideTooltips();
      }

      if (this.chartOptionsList.length) {
        let tmp = JSON.stringify(this.chartOptionsList);
        this.chartOptionsList = [];
        setTimeout(() => {
          self.chartOptionsList = JSON.parse(tmp);
        }, 200);
      }


      this.$nextTick(function() {
        self.prepareData();
      });

    }
  },
  mounted() {

    if (this.$ls.get('meteogram_sync_tooltip')) {
      this.syncTooltip = this.$ls.get('meteogram_sync_tooltip');
    }

    let utc = true;
    if (this.tz !== 'utc') utc = false;
    Highcharts.setOptions({
      global: {
        useUTC: utc
      }
    });
  },
  methods: {
    degToCard(value) {
      /*
      value = parseFloat(value);
      if (value <= 11.25) return 'N';
      value -= 11.25;
      let allDirections = ['NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW', 'N'];
      let dIndex = parseInt(value/22.5);
      return allDirections[dIndex] ? allDirections[dIndex] : 'N';
      */

      let allDirections = ['S', 'SV', 'V', 'JV', 'J', 'JZ', 'Z', 'SZ'];
      value += 22.5;
      if (value < 0) {
        value = 360 - Math.abs(value) % 360;
      }
      else {
        value = value % 360;
      }

      let dIndex = parseInt(value / 45);
      return allDirections[dIndex] ? allDirections[dIndex] : 'S';

    },
    getMaxValue(arr) {
      let carr = arr.map((v,i) => (v[1] !== null ? v[1] : null))
      return Math.max.apply(null, carr);
    },
    getMaxValueFromMultipleArraysSummed(arr1, arr2) {
      let max1 = this.getMaxValue(arr1);
      let max2 = this.getMaxValue(arr2);
      return  this.myRound(max1 + max2, 0);
    },
    getMaxValueFromMultipleArrays(arr1, arr2) {
      let max1 = this.getMaxValue(arr1);
      let max2 = this.getMaxValue(arr2);
      if (max1 > max2) return max1;
      return max2;
    },
    roundToCeilFive(val, num) {
      let final = Math.ceil(val / num) * num;
      if (final === 0) final = 5;
      return final;
    },
    getPressMin(arr) {
      let carr = arr.map((v,i) => (v[1] !== null ? v[1] : null))
      let v =  Math.min.apply(null, carr);
      if (v <= 990) return v-5;
      else return 990;
    },
    getPressMax(arr) {
      let carr = arr.map((v,i) => (v[1] !== null ? v[1] : null))
      let v =  Math.max.apply(null, carr);
      if (v >= 1020) return v+5;
      else return 1020;
    },
    prepareData: function(v) {
      const self = this;

      if (this.json_data) {

        this.chartOptionsList = [
          {
            id: 'tvzd',
            title: { text:'Teplota vzduchu' },
            subtitle: {
              text:  this.json_data.Air_temperature_at_2m.comment + ' (' + this.json_data.Air_temperature_at_2m.unit + ')',
            },
            tooltip: {
              valueSuffix: '°C',
              valueDecimals: 1
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:1,
              plotLines: [{ value: 0, color: 'rgba(0, 170, 255, 1)', width:1, zIndex:2}]
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
              }
            ],
            series: [
              {
                type: 'spline',
                color: '#ff0000',
                negativeColor: '#0000ff',
                name: 'Teplota vzduchu',
                marker: { enabled: true, symbol: 'circle', radius:2  },
                data: this.json_data.Air_temperature_at_2m.data.map(function(item) {
                  let val = item[1];
                  return ([item[0] * 1000, val]);
                }),
                // data: this.json_data.temp.map(v => v - 273.15)   // K na °C
              },
              /*
            {
              type: 'spline',
              color: '#6ed700',
              negativeColor: '#572600',
              name: 'Teplota pôdy',
              marker: { enabled: true, symbol: 'circle', radius:2 },
              data: this.json_data.surf_temp.map((v,i) => [self.json_data.datetime[i] * 1000, v - 273.15 ])
              // data: this.json_data.surf_temp.map(v => v - 273.15)   // K na °C
            },
            {
              type: 'spline',
              color: '#0b006f',
              name: 'Relatívna vlhkosť',
              marker: { enabled: true, symbol: 'circle', radius:2 },
              data: this.json_data.humi_rel.map((v,i) => [self.json_data.datetime[i] * 1000, v * 100 ]),
              valueSuffix: '%',
              valueDecimals: 1
            },

             */

            ]
          },
          {
            id: 'cloud',
            title: {text:'Oblačnosť' },
            subtitle: { text:
                  'Celková / nízka / stredná / vysoká oblačnosť  (' + this.json_data.Total_cloud_cover.unit + ')' },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:20,
              allowDecimals: false,
              min:0,
              max:100,
              plotLines: [],
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
                max:100
              }
            ],
            series: [
              {
                type: 'column',
                color: '#f3cc00',
                fillOpacity: 0.5,
                name: this.json_data.Total_cloud_cover.comment,
                marker: { enabled: false },
                groupPadding: 0,
                pointPadding: 0.1,
                borderRadius: 0,
                // data: this.json_data.cloud_total.map((v,i) => [self.json_data.datetime[i] * 1000, v * 100 ])
                data: this.json_data.Total_cloud_cover.data.map(function(item) {
                  let val = item[1];
                  return ([item[0] * 1000, val]);
                }),

                // data: this.json_data.temp.map(v => v - 273.15)   // K na °C
              },
              {
                type: 'spline',
                color: '#b60000',
                name: this.json_data.Low_cloud_cover.comment,
                marker: { enabled: true, symbol: 'circle', radius:2 },
                data: this.json_data.Low_cloud_cover.data.map(function(item) {
                  let val = item[1];
                  return ([item[0] * 1000, val]);
                }),

                // data: this.json_data.cloud_low.map((v,i) => [self.json_data.datetime[i] * 1000, v * 100 ])
                // data: this.json_data.surf_temp.map(v => v - 273.15)   // K na °C
              },
              {
                type: 'spline',
                color: '#6ed700',
                name: this.json_data.Medium_cloud_cover.comment,
                marker: { enabled: true, symbol: 'circle', radius:2 },
                data: this.json_data.Medium_cloud_cover.data.map(function(item) {
                  let val = item[1];
                  return ([item[0] * 1000, val]);
                }),

                // data: this.json_data.cloud_middle.map((v,i) => [self.json_data.datetime[i] * 1000, v * 100 ])
                // data: this.json_data.surf_temp.map(v => v - 273.15)   // K na °C
              },
              {
                type: 'spline',
                color: '#0000ff',
                name: this.json_data.High_cloud_cover.comment,
                marker: { enabled: true, symbol: 'circle', radius:2 },
                data: this.json_data.High_cloud_cover.data.map(function(item) {
                  let val = item[1];
                  return ([item[0] * 1000, val]);
                }),
                // data: this.json_data.cloud_high.map((v,i) => [self.json_data.datetime[i] * 1000, v * 100 ])
                // data: this.json_data.surf_temp.map(v => v - 273.15)   // K na °C
              },




            ]
          },
          {
            id: 'precip',
            title: { text:'Zrážky' },
            subtitle: { useHTML:true, align:'center', text:  '<div style="text-align:center">' + this.json_data.Total_precipitation.comment + ' (' + this.json_data.Total_precipitation.unit +')<br>' +
                  this.json_data.Snowfall.comment + ' (' + this.json_data.Snowfall.unit +')</div>',
              style: {
              fontSize: '12px'
              }
            },
            tooltip: {
              valueSuffix: 'mm',
              valueDecimals: 1
            },
            yAxis: [{
              min:0,
              max: self.roundToCeilFive(self.getMaxValueFromMultipleArraysSummed( self.json_data.Snowfall.data,  self.json_data.Total_precipitation.data), 5),
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:0.5,
              plotLines: [],
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
                min:0
              }
            ],
            plotOptions : {
              column: {
                connectNulls: false,
                animation: false,
                stacking: 'normal',
                borderRadius: 0,
                states: {
                  hover: {
                    lineWidthPlus: 0
                  }
                }
              }
            },
            series: [
              {
                type: 'column',
                color: 'rgba(100,200,255, 0.7)',
                name: 'Snehové zrážky',
                groupPadding: 0,
                pointPadding: 0,
                pointPlacement: -0.5,
                borderRadius: 0,
                marker: { enabled: false },
                // data: this.json_data.prec_snow_strat.map((v,i) => [self.json_data.datetime[i] * 1000, v])
                data: this.json_data.Snowfall.data.map(function(item) {
                  let val = item[1];
                  return ([item[0] * 1000, val]);
                }),
                dataLabels: {
                  enabled: true,
                  filter: {
                    operator: '>',
                    property: 'maxValue',
                    value: 0
                  },
                  style: {
                    fontSize: '8px',
                    color: 'gray'
                  }
                }
              },
              {
                type: 'column',
                color: '#0000ff',
                name: 'Zrážky',
                borderRadius: 0,
                groupPadding: 0,
                pointPadding: 0,
                pointPlacement: -0.5,
                marker: { enabled: false },
                data: this.json_data.Total_precipitation.data.map(function(item) {
                  let val = item[1];
                  return ([item[0] * 1000, val]);
                }),
              }


            ]
          },
          {
            id: 'press',
            title: { text:'Tlak' },
            subtitle: { text:  this.json_data.Mean_sea_level_pressure.comment + ' (' + this.json_data.Mean_sea_level_pressure.unit + ')' },
            tooltip: {
              valueSuffix: 'hPa',
              valueDecimals: 1
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:2,
              plotLines: [{ value: 1013.25, label: { text: 'Priemerný atmosférický tlak (1013 hPa)', style:{ opacity:0.5}}, color: 'rgba(0, 170, 255, 1)', width:1, zIndex:20}],
              min: self.getPressMin(this.json_data.Mean_sea_level_pressure.data),
              max: self.getPressMax(this.json_data.Mean_sea_level_pressure.data)
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
              }
            ],
            series: [
              {
                type: 'spline',
                color: '#0000ff',
                name: 'Tlak',
                marker: { enabled: true, symbol: 'circle', radius:2 },
                data: this.json_data.Mean_sea_level_pressure.data.map(function(item) {
                  let val = item[1];
                  return ([item[0] * 1000, val]);
                }),
                // data: this.json_data.press.map((v,i) => [self.json_data.datetime[i] * 1000,  (v !== null ? v / 100.0 : null) ])
                // data: this.json_data.temp.map(v => v - 273.15)   // K na °C
              },

            ]
          },
          {
            id: 'wind',
            title: { text:'Vietor' },
            subtitle: {  text: 'Rýchlosť, nárazy a smer vetra vo výške 10m nad povrchom (' + this.json_data.Wind_speed_at_10_m.unit + ')',
            },
            tooltip: {
              valueSuffix: '',
              valueDecimals: 1
            },
            xAxis: [{
              offset: 40
            }, {}],
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:1,
              plotLines: [],
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
              }
            ],
            series: [
              {
                type: 'column',
                color: '#7cc203',
                name: 'Nárazy vetra',
                tooltip: {
                  valueSuffix: 'm/s',
                  valueDecimals: 1
                },
                marker: { enabled: false },
                groupPadding: 0,
                pointPadding: 0.2,
                borderRadius: 0,
                borderColor: '#6da226',
                data: this.json_data.Wind_gust_at_10_m.data.map(function(item) {
                  let val = item[1];
                  if (val <= 8) val = null;
                  return ([item[0] * 1000, val]);
                }),
              },
              {
                type: 'spline',
                color: '#000090',
                name: 'Rýchlosť vetra',
                tooltip: {
                  valueSuffix: 'm/s',
                  valueDecimals: 1
                },
                marker: { enabled: true, symbol: 'circle', radius:2 },
                data: this.json_data.Wind_speed_at_10_m.data.map(function(item) {
                  let val = item[1];
                  return ([item[0] * 1000, val]);
                }),
              },
              {
                type: 'windbarb',
                color: '#000000',
                // animation: false,
                name: 'Smer vetra',
                marker: { enabled: false },
                showInLegend: false,
                tooltip: {
                  valueSuffix: '',
                  valueDecimals: 0
                },
                data: this.json_data.Wind_direction_at_10_m.data.map(function(item, key) {
                  let val_direction = item[1];
                  let val_speed = self.json_data.Wind_speed_at_10_m.data[key][1];
                  return ([item[0] * 1000, val_speed, val_direction]);
                }),

              },


            ]
          },
        ];

        this.addGlobalParameters();





      }

    },

    addGlobalParameters: function() {
      const self = this;

      this.chartOptionsList.forEach(function(v, i) {

        v.credits = false;
        v.chart = {
          zoomType: 'x',
          animation:false,
          credits: false,
          events: {
            render: self.chartLoaded,
            load: self.bindHideTooltips
          },
          zooming: {
            mouseWheel: {
              enabled: false
            }
          }
        };

        v.legend = {
          enabled: false
        };

        v.tooltip.shared = true;
        v.tooltip.shadow = false;
        v.tooltip.useHTML = true;
        v.tooltip.hideDelay = 100;
        /*
        v.tooltip.positioner = function () {
          return {
            x: 30,
            y: 15
          };
        };

         */
        v.tooltip.headerFormat = '';
        v.tooltip.borderWidth = 1;
        v.tooltip.backgroundColor = 'white';

        v.tooltip.formatter = function(e) {
          var points = this.points,
              i,
              result = '';

          function formatPoint(p) {
            let suffix = v.tooltip.valueSuffix;
            let v_t = self.myRound(p.point.y, v.tooltip.valueDecimals);
            if (typeof p.point.high !== "undefined") {
              v_t += ' - ' + self.myRound(p.point.high, v.tooltip.valueDecimals);
            }
            if (typeof p.point.direction !== "undefined") {
              let val = p.point.direction;
              if (val < 0) val = 360 + val;
              let dir = self.myRound(val, 0);
              v_t = self.degToCard(dir) + ' (' + dir + '°)';
              suffix = '';
            }
            if (p.point.y === null) return '';
            if (p.point.y === '') return '';
            if (isNaN(p.point.y)) return '';

             // console.log(p.point.series.userOptions.tooltip);

            let sf = v.tooltip.valueSuffix;
            if (
                typeof p.point.series.userOptions.tooltip !== 'undefined' &&
                typeof p.point.series.userOptions.tooltip.valueSuffix !== 'undefined') {
                  sf = p.point.series.userOptions.tooltip.valueSuffix;
            }


            if (sf !== '') {
              sf = ' ' + sf;
            }




            return '<span style="padding-left: 5px; color:' + p.point.color + '">\u25A0</span> ' + p.series.name + ': <b>' + v_t + sf +'</b>&nbsp;&nbsp;<br>'
            // return ' <span style="padding-left: 20px; color:' + p.point.color + '">\u25A0</span> ' + p.series.name + ': <b>' + v_t + suffix +'</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
          }

          for (i = 0; i < points.length; i++) {
            result += formatPoint(points[i])
          }

          let dt = self.showDateTimeTZ(points[0].x, 'DD. MM. YYYY HH:mm');
          if (self.tz === 'utc') {
            dt += ' UTC';
          }
          // let dt = self.$moment.utc(points[0].x).format('DD.MM.YYYY HH:mm') + ' UTC';

          result = '<b style="padding-bottom: 3px; display: block; font-size: 12px">'+dt + '</b>' + result;
          return result;
        }


        /*
        v.yAxis[0].crosshair = {
          enabled: false,
          color: '#999',
          width: 1,
        };

         */


        let tempXAxis = [];
        if (typeof v.xAxis !== "undefined") {
          tempXAxis = v.xAxis;
        }

        v.xAxis = [{
          crosshair: {
            enabled: true,
            width: 10,
          },
          type: 'datetime',
          // tickInterval: self.computedTickInterval,
          tickInterval: 2 * 60 * 60 * 1000,
          tickWidth: 2,
          tickLength: 5,
          tickColor: '#000000',
          minorGridLineColor: '#999',
          minorGridLineDashStyle: 'dot',

          minorTickInterval: 1 * 60 * 60 * 1000,
          minorTickWidth: 1,
          minorTickLength: 3,

          dateTimeLabelFormats: {
            month: '%e. %b',
            year: '%b',
            hour: '%H:%M'
          },
          lineColor: '#000',
          lineWidth: 1,
          gridLineWidth: 1,
          gridLineDashStyle: 'dot',
          gridLineColor: '#999',
          labels:{
            formatter: function () {
              const label = this.axis.defaultLabelFormatter.call(this);
              if (/^[0-9]{2}:[0-9]{2}$/.test(label)) {
                // console.log('ano')
              } else {
                return '<strong>' + label + '</strong>'
              }
              return label;
            },
            style: { fontSize:'11px' },   rotation: 270, x:0, y:12},
          startOnTick: false,
          endOnTick: false,
          minPadding: 0,
          maxPadding: 0,
          plotLines: [],
          events: {
            setExtremes: function(event) {
              self.syncExtremes(this, event);
            }
          },
        },
          { // Top X axis
            linkedTo: 0,
            type: 'datetime',
            tickInterval: 24 * 3600 * 1000,
            labels: {
              format: '{value:<span style="font-size: 12px; font-weight: normal">%A</span>}',
              align: 'left',
              x: 3,
              y: 8
            },
            opposite: true,
            tickLength: 20,
            gridLineWidth: 1
          }
        ];

        v.xAxis[0] = {...v.xAxis[0], ...tempXAxis[0]};


        if (typeof v.plotOptions === "undefined") {

          v.plotOptions = {
            spline: {
              connectNulls: false,
              animation: false,
              states: {
                hover: {
                  lineWidthPlus: 0
                }
              }
            },
            column: {
              connectNulls: false,
              animation: false,
              states: {
                hover: {
                  lineWidthPlus: 0
                }
              }
            },
            areasplinerange: {
              connectNulls: false,
              animation: false,
              states: {
                hover: {
                  lineWidthPlus: 0
                }
              }
            },
            columnrange: {
              connectNulls: false,
              animation: false,
              states: {
                hover: {
                  lineWidthPlus: 0
                }
              }
            },
            candlestick: {
              connectNulls: false,
              animation: false,
              states: {
                hover: {
                  lineWidthPlus: 0
                }
              }
            },
            windbarb: {
              connectNulls: false,
              animation: false,
              vectorLength: 13,
              lineWidth: 1,
              dataGrouping: {
                enabled: false,
              },
              states: {
                hover: {
                  lineWidthPlus: 0
                }
              }
            }
          };

        }

        v.plotOptions.series = {};
        v.plotOptions.series.point = {};

        if (self.syncTooltip) {
          v.plotOptions.series.point.events = {
            mouseOver: function (event) {
              self.sync(this, event, 'over');
            },
            mouseOut: function (event) {
              self.sync(this, event, 'out');
            }
          };
        } else {
          v.plotOptions.series.point.events = {
            mouseOver: undefined,
            mouseOut: undefined,
          }
        }

        v.plotOptions.series.states = {
          hover: {
            halo: {
              size: 0
            }
          },
          inactive: {
            enabled: false
          }
        };

        // pridaj polnocne plotlines

        let total_count = self.json_data.Air_temperature_at_2m.data.length;
        let min_dt = self.json_data.Air_temperature_at_2m.data[0][0];
        let max_dt = self.json_data.Air_temperature_at_2m.data[total_count-1][0];

        for (let i = min_dt; i <= max_dt; i=i+(60*60)) {

          let hour = parseInt(self.showDateTimeTZ(i*1000, 'HH'))

          if (hour===0) {
            v.xAxis[0].plotLines.push({ value: i*1000, color: 'rgba(0, 0, 0, 0.3)', width:1, zIndex: 2}); // ciara na polnoc
          }
        }

        // pridat vychod zapad slnka
        let ss = self.getSunriseSunset(min_dt, max_dt, self.json_station.lat, self.json_station.lon);
        v.xAxis[0].plotBands = [];
        let prevItem = [];
        ss.forEach(function(item, i) {
          if (i === 0) {
            prevItem = item;
          } else {

            let from = prevItem[1];
            let to = item[0];

            v.xAxis[0].plotBands.push({from: from, to: to, color: 'rgba(210,210,210,0.3)', zIndex: 1}); // ciara na polnoc
            prevItem = item;
          }
        });



        if (self.$mq === 'xs' || self.$mq === 'sm') {
          delete v.yAxis[1];
          v.yAxis[0].opposite = true;
          v.tooltip.enabled = false;

          v.series.forEach(item => {
            item.marker.enabled = false;
          })

        }

        v.isLastChart = false;
        if (i === self.chartOptionsList.length - 1) {
          v.isLastChart = true;
        }


      });
    },
    getSunriseSunset: function(min_dt, max_dt, lat, lon) {
      let day_sec = 24 * 60 * 60;
      let sunsetSunriseLimits = [];
      for (let d = min_dt - day_sec; d < max_dt + day_sec; d += day_sec) {
        let t = this.$SunCalc.getTimes(new Date(d * 1000), lat, lon);
        sunsetSunriseLimits.push([t.sunrise.getTime(), t.sunset.getTime()]);
      }
      return sunsetSunriseLimits;

    },
    hideCurrentTooltip(vm) {
      this.hideTooltips();
    },
    sync: function(vm, event, type) {
      this.$refs.highcharts.forEach(({ chart }) => {

        if (chart === vm.series.chart) return;

        let points = [];
        if (typeof chart !== 'undefined') {
          chart.series.forEach((series) => {
            series.data.forEach((point) => {
              if (point.x === vm.x) {
                if (type === 'over') {
                  point.setState('hover');
                  points.push(point);
                  // chart.tooltip.refresh([point]);
                  // chart.xAxis[0].drawCrosshair(event, point);
                } else {
                  point.setState('');
                  chart.tooltip.hide();
                  chart.xAxis[0].hideCrosshair();
                }
              }
            });

          });

          if (points.length > 0) {
            chart.tooltip.refresh(points);
            let e = chart.pointer.normalize(event)
            chart.xAxis[0].drawCrosshair(e, points[0]);
          }
        }

      });
    },
    syncExtremes: function(vm, e) {
      if (e.trigger !== 'syncExtremes') { // Prevent feedback loop

        const shouldShowResetZoom = !(e.min === undefined && e.max === undefined);

        this.$refs.highcharts.forEach(({ chart }) => {
          if (chart !== vm.series.chart) {
            if (chart.xAxis[0].setExtremes) { // It is null while updating
              chart.xAxis[0].setExtremes(
                  e.min,
                  e.max,
                  undefined,
                  false,
                  { trigger: 'syncExtremes' }
              );
            }
          }

          if (shouldShowResetZoom && !chart.resetZoomButton ) {
            chart.showResetZoom();
          } else if(!shouldShowResetZoom && chart.resetZoomButton) {
            chart.resetZoomButton = chart.resetZoomButton.destroy();
          }






        });
      }
    },
    chartLoaded: function(e) {
      const self = this;
      if (e.target.userOptions.isLastChart === true) {
        self.isLoading = false;
      }
    },
    redrawCharts() {
      const self = this;
      if (self.$refs.highcharts.length) {
        self.$refs.highcharts.forEach((cmp) => {
          cmp.chart.redraw();
        });
      }

      this.$nextTick(function() {
        window.dispatchEvent(new Event('resize'));
      });

    },
    showDateTimeTZ(value, format) {
      let ttz = 'UTC';
      if (this.tz !== 'utc') {
        ttz = Intl.DateTimeFormat().resolvedOptions().timeZone
      }

      let momUTC = this.$moment.utc(value);
      return this.$moment.tz(momUTC.clone(), ttz).format(format);
    },
    hideTooltips() {
      this.$refs.highcharts.forEach(({ chart }) => {
        if (typeof chart !== 'undefined') {
          chart.series.forEach((series) => {
            series.data.forEach((point) => {
              point.setState('');
              chart.tooltip.hide();
              chart.xAxis[0].hideCrosshair();
            });
          });
        }
      });

    },
    bindHideTooltips(wm){
      if (!this.syncTooltip) {
        wm.target.renderTo.removeEventListener('mouseout', this.hideTooltips);
        wm.target.renderTo.addEventListener('mouseout', this.hideTooltips)
      } else {
        wm.target.renderTo.removeEventListener('mouseout', this.hideTooltips);
      }
    },





  }

}
</script>

<style lang="scss">
.chart {
  height: 320px;
  margin: 0 auto;
}

.chart-320 {
  height: 320px;
  margin: 0 auto;
}

.chart-420 {
  height: 420px;
  margin: 0 auto;
}

.chart-520 {
  height: 520px;
  margin: 0 auto;
}

/*
.aladin-chart {
  .highcharts-label.highcharts-tooltip {
    top: 23px !important;
    left: 40px !important;
  }
}

 */

</style>

